<div class="navigation">
  <app-button
    *ngFor="let nav of navigation"
    [text]="nav.display"
    [icon]="nav.icon"
    [disabled]="!!nav.disabled"
    textAlign="flex-start"
    [fullWidth]="true"
    (click)="navigate(nav)"
    [style.opacity]="active(nav) ? '1' : '0.8'"
    [color]="active(nav) ? 'white' : 'var(--text-default)'"
    [backgroundColor]="
      active(nav)
        ? nav.backgroundColor || 'var(--slate-500)'
        : 'var(--slate-100)'
    "
  ></app-button>
</div>
